import React, { useContext } from "react";
import { BreadcrumbWidget } from "@usap/widgets";
import { LocalContext } from "../../helpers/useLocalContext";

export default function Breadcrumb({ screenSize, dynamicApiData }) {
  const { localContext } = useContext(LocalContext);
  const { Link } = localContext;

  const isDesktop = screenSize === "large";
  if (!dynamicApiData || !Object.keys(dynamicApiData).length) return "";

  return (
    <BreadcrumbWidget
      isDesktop={isDesktop}
      links={dynamicApiData}
      Link={Link}
    />
  );
}
